import { DOCUMENT_STATUS_FOR_MODAL_TO_OPEN_MESSAGES } from '../enums/common'
import { IUploadWithRetryFormState } from '../interfaces/Upload'
import { IFolderContent } from '../interfaces/Folder'

export const getDocumentStatusTitle = (
  docState: IUploadWithRetryFormState,
  userDetails: IFolderContent
) => {
  const { statusVerification } = docState
  const documentStatus: number = statusVerification[0]
  const { nom, prenom } = userDetails
  if (documentStatus === 5) {
    return `${DOCUMENT_STATUS_FOR_MODAL_TO_OPEN_MESSAGES[documentStatus]} ${prenom} ${nom}`
  }

  return DOCUMENT_STATUS_FOR_MODAL_TO_OPEN_MESSAGES[documentStatus]
}
